import type { PlateElementProps } from 'platejs/react'

import styles from './styles.module.css'
import { LinkElement } from '../nodes/LinkElement'

export const SimpleLinkElementUI = ({
  attributes,
  children,
  element,
}: PlateElementProps<LinkElement>): JSX.Element => {
  const href = LinkElement.getHref(element)

  return (
    <a
      {...attributes}
      className={styles.link}
      contentEditable={false}
      href={href}
      target="_blank"
      rel="noopener nofollow"
    >
      {children}
    </a>
  )
}
